import clsx from "clsx";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useUpdateContactStateMutation } from "../../../../../../features/contactsApi";
import { addBannerWithTimeout } from "../../../../../lib/centralizedBanner/slice";
import { ContactDTO, ContactType } from "../../../../../lib/filters/dto";
import { keycloak } from "../../../../../lib/keycloak";
import { useAppDispatch } from "../../../../../lib/redux/hooks";
import { EditIcon } from "../../../../../ui/icons/edit";
import { UserCheckIcon } from "../../../../../ui/icons/userCheck";
import { UserXIcon } from "../../../../../ui/icons/userX";
import Button from "../../../../../ui/molecules/button";
import { KoModal } from "../../../../targetList/contacts/koModal";
import { LeadTakenModal } from "../../../../targetList/contacts/leadTakenModal";
import { ContactStateEnum } from "../../../../targetList/dto";
import { PersonDTO } from "../../../people/dto";

interface Props {
  employee: PersonDTO;
  setEmployee: React.Dispatch<React.SetStateAction<PersonDTO | undefined>>;
  navigate: (section: 'list' | 'new' | 'edit') => void;


  isInTargetList: boolean;
  contact?: ContactDTO<ContactType.PERSON>
  setContactInfo: React.Dispatch<React.SetStateAction<{
    contactCount: number | null;
    id: string;
    outcome: ContactStateEnum;
    outcomeInfo: string | null;
    callAttempts: number | null;
    noResponseCount: number | null;
  } | undefined>>
}
export function AccordionEmployee(props: Props) {
  const dispatch = useAppDispatch()
  const { targetId, targetContactId } = useParams()

  const [updateContactState, { isLoading: isUpdatingContactState }] = useUpdateContactStateMutation()

  const handleUpdateContactState = async (newOutcome: ContactStateEnum, newOutcomeInfo: string | null) => {
    try {
      await updateContactState({
        contactId: props.contact?.id ?? "",
        outcome: newOutcome,
        outcomeInfo: newOutcomeInfo,
        contactType: ContactType.PERSON,
        targetId: targetId!,
        companyId: targetContactId!
      }).unwrap();
      setOpenLeadTakenModal(false);
      dispatch(addBannerWithTimeout({
        variant: "success",
        message: "Stato del contatto aggiornato con successo.",
      }));
    } catch (error) {
      const res = error as unknown as { status: number, data: { errors: { message: string }[] } };
      let message = "Si è verificato un errore durante l'aggiornamento dello stato del contatto.";
      const errors = res?.data?.errors ?? [];
      if (errors?.some(e => e.message.includes("has already reached the maximum number of calls"))) {
        message = "Il contatto ha già raggiunto il numero massimo di chiamate consentite.";
      } else if (errors?.some(e => e.message.includes("Contact ID is required"))) {
        message = "Non è possibile prendere il Lead perché non ancora presente in Lista Target. Riprova domani.";
      } else if (errors?.some(e => e.message.includes("Invalid transition from DRAFT to DRAFT"))) {
        message = "Il contatto è già nello stato 'Da Lavorare'";
      }
      dispatch(addBannerWithTimeout({
        variant: "error",
        message: message,
      }));
    }
  }

  const [openLeadTakenModal, setOpenLeadTakenModal] = useState<boolean>(false);
  const [openKoModal, setOpenKoModal] = useState<boolean>(false);

  return (
    <div
      className="w-full border-t border-neutral-200 transition-all"
      key={props.employee.id}
    >
      <LeadTakenModal
        person={props.employee}
        isLoading={isUpdatingContactState}
        handleConfirm={handleUpdateContactState}
        listIndex={-1}
        isOpen={openLeadTakenModal}
        onClose={function (): void {
          setOpenLeadTakenModal(false);
        }}
      />
      <KoModal
        isLoading={isUpdatingContactState}
        handleConfirm={handleUpdateContactState}
        listIndex={-1}
        contactId={props.contact?.id}
        isOpen={openKoModal}
        onClose={function (): void {
          setOpenKoModal(false);
        }}
      />
      <div
        className={clsx(
          "px-6 py-4 flex items-start gap-4 justify-between w-full transition-all bg-white",
          // {
          //   "bg-white": !open,
          //   "bg-neutral-50": open,
          // }
        )}
      >
        <div className="flex flex-col gap-1 truncate">
          <span className="text-label-sm text-neutral-800 font-bold uppercase">
            {props.employee.name + " " + props.employee.surname}
            {
              props.employee.phone &&
              <a className="text-label-md text-neutral-600 font-medium cursor-pointer" href={"tel:" + (props.employee.phone)}>
                {" - "}
                <span className="underline">{props.employee.phone}</span>
              </a>
            }
          </span>
          <span className="text-label-sm text-neutral-600 font-semibold">
            {props.employee.role ? props.employee.role : "N/A"}
          </span>
          <div className={clsx("flex gap-2", {
            "hidden": !props.isInTargetList,
            "blur-[2.5px]": keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator') || (props.employee && (props.employee.callsCounter >= 3))
          })}>
            <Button size={"sm"} iconPosition={"left"} icon={<UserCheckIcon color={""} size={0} />} variant={props.contact?.outcome === ContactStateEnum.LEADTAKEN ? "solid" : "outline"} color={"green"} label="Lead preso"
              disabled={keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator') || props.contact?.outcome === ContactStateEnum.LEADTAKEN || (props.contact?.outcome === ContactStateEnum.KO && props.contact?.outcomeInfo === "Registro opposizioni")}
              onClick={() => {
                // dispatch(setContactToWork({
                //   contactId: props.contact?.id ?? "",
                //   name: props.employee.name,
                //   surname: props.employee.surname,
                //   phone: props.employee.phone ?? "",
                //   privacy: props.employee.privacy,
                // }))
                setOpenLeadTakenModal(true)
              }}
            />
            <Button
              disabled={keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator') || props.contact?.outcome === ContactStateEnum.LEADTAKEN || (props.contact?.outcome === ContactStateEnum.KO && props.contact?.outcomeInfo === "Registro opposizioni")}
              size={"sm"} iconPosition={"left"} icon={<UserXIcon color={""} size={0} />} variant={props.contact?.outcomeInfo === "Registro opposizioni" ? "solid" : "outline"} color={"gray"} label="Registro opposizioni"
              onClick={() => {
                setOpenKoModal(true)
              }}
            />
          </div>
        </div>
        <div className="items-center flex">
          <Button disabled={keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator')} size={"sm"} onClick={() => {
            // dispatch(setSelectedPerson(props.employee.id));
            // dispatch(setEditPersonStatus('idle'));
            // dispatch(setTabValueDetailsPerson('form'))
            props.setEmployee(props.employee)
            props.navigate('edit')
            props.setContactInfo({
              contactCount: props.employee?.contactCount ?? null,
              id: props.contact?.id ?? "",
              outcome: props.contact?.outcome ?? ContactStateEnum.DRAFT,
              outcomeInfo: props.contact?.outcomeInfo ?? null,
              callAttempts: props.contact?.callAttempts ?? null,
              noResponseCount: props.contact?.noResponseCount ?? null
            })
          }}
            iconPosition={"only"} variant={"link"} color={"blue"} icon={<EditIcon color={"red"} size={16} />} />
        </div>
      </div>
      {/* <div
        className={clsx(
          "w-full px-6 pb-4 bg-neutral-50 flex flex-col gap-4 transition-all",
          {
            hidden: !open,
          }
        )}
      >
        <div className="flex gap-3 items-center">
          <Input disabled label="Nome" value={props.employee.name} />
          <Input disabled label="Cognome" value={props.employee.surname} />
        </div>
        <Input disabled label="Ruolo" value={props.employee.role} />
        <Input disabled label="Reparto" value={props.employee.department} />
        <div className="flex gap-3 items-end">
          <Input disabled label="Smartphone" value={props.employee.phone ?? ""} />
          <div>
            <PrivacyComponent personPhone={props.employee.phone ?? null} privacy={props.employee.privacy} section="form" />
          </div>
        </div>
        {
          props.employee.emails?.map(email => (
            <a
              rel="noreferrer"
              target="_blank"
              href={"mailto:" + email}
              className="flex items-center gap-2 text-text-sm font-medium text-neutral-600"
            >
              <MailIcon size={20} color={colors.neutral[500]} />
              <span>{email}</span>
            </a>
          ))
        }
        <a
          rel="noreferrer"
          target="_blank"
          href={props.employee.linkedinProfile}
          className="flex items-center gap-2 text-text-sm font-medium text-neutral-600"
        >
          <LinkedinIcon size={20} color={colors.neutral[500]} />
          <span>
            {props.employee.linkedinProfile &&
              props.employee.linkedinProfile.slice(0, 35) + "..."}
          </span>
        </a>
      </div> */}
    </div>
  );
}
